import React from 'react'
import { Box, CircularProgress, Typography, Stack } from '@mui/material'

/** État de chargement centré, occupe toute la hauteur disponible. */
export const LoadingState = ({ label = 'Chargement en cours' }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={2}
    sx={{ flex: 1, minHeight: 220, py: 6, textAlign: 'center' }}
  >
    <CircularProgress size={44} color="primary" />
    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
      {label}
    </Typography>
  </Stack>
)

/** Chargement occupant tout l'écran, utilisé entre deux étapes de scan. */
export const FullScreenLoader = ({ label = 'Chargement en cours' }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={2}
    sx={{
      height: 'var(--app-vh)',
      bgcolor: 'background.default',
      px: 4,
      textAlign: 'center',
    }}
  >
    <CircularProgress size={52} color="primary" />
    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
      {label}
    </Typography>
  </Stack>
)

/** État vide : icône optionnelle, titre, description. */
export const EmptyState = ({ icon, title, description }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={1.5}
    sx={{ flex: 1, minHeight: 180, py: 5, px: 2, textAlign: 'center' }}
  >
    {icon ? (
      <Box sx={{ color: 'text.disabled', '& .MuiSvgIcon-root': { fontSize: 56 } }}>
        {icon}
      </Box>
    ) : null}
    <Typography variant="h6">{title}</Typography>
    {description ? (
      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 320 }}>
        {description}
      </Typography>
    ) : null}
  </Stack>
)
